<template>
  <div class="py-2 container-fluid">
    <div
      class="page-header min-height-300 border-radius-xl"
      :style="{
        backgroundImage: 'url(' + require('@/assets/img/curved-images/curved14.jpg') + ')',
        backgroundPositionY: '50%',
      }"
    >
      <span class="mask bg-gradient-success opacity-6"></span>
      <div style="display: flex; align-items: center; justify-content: center">
        <div style="position: absolute; left: 32%; transform: translateX(-50%)">
          <img
            :src="logo"
            style="height: 60px; z-index: 999"
            alt="main_logo"
          />
        </div>
        <div style="filter: invert(1); position: absolute; left: 68%; transform: translateX(-50%)">
          <img
            :src="steelcaseLogo"
            style="z-index: 999"
            alt="steelcase_logo"
          />
        </div>
      </div>
    </div>
    <div class="mx-4 overflow-hidden card card-body blur shadow-blur mt-n6">
      <div class="d-flex align-items-center justify-content-between px-4">
        <h3 class="mb-0">Steelcase Program</h3>
        <button
          class="btn btn-lg"
          :class="all_powder_amount_settings_sent_to_plcs ?  'btn-outline-secondary':'btn-success'"
          :disabled="all_powder_amount_settings_sent_to_plcs"
          style="font-weight: bold;"
          @click="$router.push({ name: 'SendRecipeSettingsToPLCs' })"
        >
          {{ all_powder_amount_settings_sent_to_plcs ? 'ALL PLC(s) UP TO DATE':'SEND SETTINGS TO PLCs' }}
        </button>
      </div>
      <hr class="horizontal dark mt-1 mb-2" />
      <LineListSteelCase />
    </div>
  </div>
</template>

<script>
import setTooltip from "@/assets/js/tooltip.js";
import LineListSteelCase from "./components/LineListSteelCase.vue";
import logo from "@/assets/img/logo-ct-white.png";
import steelcaseLogo from "@/assets/img/steelcase-logo.svg";
import axios from "axios";

export default {
  name: "SteelCase",
  components: {
    LineListSteelCase,
  },
  data() {
    return {
      logo,
      steelcaseLogo,
      all_powder_amount_settings_sent_to_plcs: false,
    };
  },
  computed: {},
  mounted() {
    this.$store.state.isAbsolute = true;
    setTooltip();
    this.getData();
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
  },
  methods: {
    async getData() {
      await axios.get("api/v1/steelcase/boolean-are-all-powder-amount-settings-sent-to-plcs/")
        .then((response) => {
          this.all_powder_amount_settings_sent_to_plcs = response.data.all_powder_amount_settings_sent_to_plcs;
        })
        .catch((error) => {
          console.error("Error fetching powder amount settings:", error);
        });
    },
  },
};
</script>
